import $ from 'jquery';
import _ from 'lodash';
import React from 'react';

var ItemCountControl = React.createClass({
    getIncrement: function() {
        return Math.min(
            this.props.interval - (this.props.count % this.props.interval),
            this.props.interval
        );
    },
    canIncrement: function () {
        if (this.props.max == null) {
            return true;
        }
        return this.props.count + this.getIncrement() <= this.props.max;
    },
    render: function() {
        var canIncr = this.canIncrement() ? '': 'inactive',
            pricePerTextSingular = this.props.pricePerText || 'kpl',
            pricePerTextPlural = this.props.pricePerTextPlural || 'kpl',
            pricePerText = this.props.count == 1 ? pricePerTextSingular : pricePerTextPlural,
            containerClasses = "count-controls-container ".concat(this.props.extraContainerClass);

        return (
            <div className="col price-and-controls">
                <div className={containerClasses}>
                <div className="price-and-count">
                    <span className="price">{(1.0 * this.props.unitPrice).toFixed(2).replace('.', ',')}&nbsp;€<br /></span>
                    <span className="count-and-total-price">
                        <span className={this.props.isWheelset ? "wheel-set-count" : "count"}>{parseInt(this.props.count)}&nbsp;{pricePerText} </span>
                        <span className="total-price">({(this.props.unitPrice * this.props.count).toFixed(2).replace('.', ',')}&nbsp;€)<br /></span>
                    </span>
                </div>
                    <div className="count-controls">
                        <span className={'increment ' + canIncr} onClick={this.increment}>
                            +
                        </span>
                        <span className={'decrement ' + ((this.props.count <= this.props.interval) ? 'inactive': '')} onClick={this.decrement}>
                            ‒
                         </span>
                    </div>
                </div>
            </div>
        );
    },
    increment: function () {
        var incrVal = this.getIncrement();
        if (this.canIncrement()) {
            this.props.onChange(parseInt(this.props.count) + incrVal);
        }
    },
    decrement: function () {
        var decrVal = Math.min(
            Math.max(this.props.interval, this.props.count % this.props.interval),
            this.props.interval
        );
        if (decrVal < this.props.count) {
            this.props.onChange(parseInt(this.props.count) - decrVal);
        }
    }
});

ItemCountControl.defaultProps = {extraContainerClass: ""};

var calculateNotificationLocation = function (e=null, extraCls='') {
  // Updates shopping cart notification
  //    Nav bar heights:
  //      - Desktop: 97px
  //      - Mobile: 60px
  const isMobile = $(window).width() < 850,
        marginTop = isMobile ? 60 : 97,
        notification = e ? e : $('.jGrowl-notification');

  const scrollPos = $(window).scrollTop();
  if (scrollPos < marginTop) {
    notification.removeClass('scrolled-past-navbar');
    const oldTop = parseInt(notification.css('top')),
          newTop = Math.max(0, (marginTop - scrollPos));

    if (isMobile) {
      notification.css('top', `${newTop}px`);
    } else {
      notification.css('margin-top', `calc(${newTop}px + 1em)`);
    }
  } else {
    notification.addClass('scrolled-past-navbar ' + extraCls);
  }
};

export default {
  ItemCountControl: ItemCountControl,
  calculateNotificationLocation: calculateNotificationLocation,
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/product-helpers.js
 **/